<div class="notMob">
  @if (firstnode | async; as item) {
    <div >
      @if (item.uid=='SeqirusFluadRWEFirstComponent') {
        <div class="hidden-sm">
          <div class="breadcrumbs--page-nav hidden-xs hidden-sm">
            <div class="container">
              <p><a routerLink="/">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a routerLink="/products">{{"statictext.products" | cxTranslate}}</a><span> &gt; </span><strong>{{"statictext.realworldevidence" | cxTranslate}}</strong></p></div>
            </div>
          </div>
        }
        @if (firstnode | async; as item) {
          <section class="landingpage_videoContainer fluad-video hidden-xs hidden-sm">
            @if (item.uid=='SeqirusFluadRWEFirstComponent') {
              <div>
                @if (item.mediaVideo) {
                  <div>
                    <video autoplay muted="" playsinline="" class="rwe_video" preload="auto">
                      <source [src]="getImage(item.mediaVideo)" type="video/mp4">
                    </video>
                  </div>
                }
              </div>
            }
          </section>
        }
      </div>
    }
  </div>


  @if (firstnode | async; as item) {
    <section class="landingpage_videoContainer  hidden-md hidden-lg">
      @if (item.uid=='SeqirusFluadRWEFirstMobComponent') {
        <div>
          @if (item.mediaVideo) {
            <div>
              <video autoplay muted="" playsinline="" class="rwe_video" preload="auto">
                <source [src]="getImage(item.mediaVideo)" type="video/mp4">
              </video>
            </div>
          }
        </div>
      }
    </section>
  }